"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DropdownContext = require("./context/DropdownContext");

var _styles = require("./styles");

var DropdownButton = function DropdownButton(_ref) {
  var children = _ref.children,
      fluid = _ref.fluid;

  var _useDropdown = (0, _DropdownContext.useDropdown)(),
      isOpen = _useDropdown.isOpen,
      changeDropdownState = _useDropdown.changeDropdownState,
      setDimensionsButton = _useDropdown.setDimensionsButton;

  var touchableRef = (0, _react.useRef)();

  var handleClick = function handleClick() {
    var dimensions = touchableRef.current.getBoundingClientRect();
    setDimensionsButton({
      width: dimensions.width,
      height: dimensions.height,
      x: dimensions.x,
      y: dimensions.y,
      pageYOffset: window.pageYOffset
    });
    changeDropdownState(!isOpen);
  };

  return /*#__PURE__*/_react.default.createElement(_styles.Touchable, {
    fluid: fluid,
    ref: touchableRef,
    onClick: handleClick
  }, children);
};

DropdownButton.defaultProps = {
  fluid: false
};
var _default = DropdownButton;
exports.default = _default;